import axios from 'axios';
import { useHistory } from 'react-router-dom';
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { clearAuth } from '../actions';

const Logout = ({ clearAuth }) => {
    const history = useHistory();
    
    useEffect(() => {
        const performLogout = async () => {
            try {
                // Call logout API
                await axios.get(`/api/logout`, {
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    }
                });
                
                // Clear Redux auth state FIRST
                clearAuth();
                
                // Clear all auth-related localStorage
                localStorage.removeItem('fsUserIdSent');
                localStorage.removeItem('isAuthenticated');
                localStorage.removeItem('authData');
                
                // Clear any other auth-related storage
                sessionStorage.clear();
                
                // Clear any cookies (if using them)
                document.cookie.split(";").forEach(function(c) { 
                    document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); 
                });
                
                // Redirect to home page (not login, since user just logged out)
                history.push('/');
                
            } catch (error) {
                console.error('Logout error:', error);
                // Even if API call fails, clear state and redirect
                clearAuth();
                localStorage.removeItem('fsUserIdSent');
                localStorage.removeItem('isAuthenticated');
                localStorage.removeItem('authData');
                sessionStorage.clear();
                history.push('/');
            }
        };
        
        performLogout();
    }, [history, clearAuth]);
    
    // Show loading state while logout is processing
    return (
        <div className="pt-5">
            <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Logging out...</span>
                </div>
                <p className="mt-3">Logging out...</p>
            </div>
        </div>
    );
};

export default connect(null, { clearAuth })(Logout);